import { useEffect, useState, forwardRef } from 'react';
import { ChevronUp } from 'lucide-react';

export const BackToTopButton = forwardRef<HTMLButtonElement>(function BackToTopButton(_, ref) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  if (!isVisible) return null;

  return (
    <button
      ref={ref}
      onClick={scrollToTop}
      className="fixed bottom-24 right-6 z-40 bg-cyan-600 hover:bg-cyan-700 text-white rounded-full p-3 shadow-lg transition-all duration-300 hover:scale-110 animate-in fade-in"
      aria-label="Back to top"
    >
      <ChevronUp className="w-6 h-6" />
    </button>
  );
});

BackToTopButton.displayName = 'BackToTopButton';
